<template>
  <div v-if="attachmentList.length > 0" class="card">
    <div class="section">
      <div v-if="!hasPayBookFee">
        <div class="section-title">
          <base-section-title title="澄清文件" />
        </div>
        <div class="section-content">
          <apply-content-lock
            v-if="!hasPayBookFee"
            title="报名后缴纳标书费才可以下载查看"
            class="file-lock-wrap"
          />
        </div>
      </div>

      <clarified-file
        v-else
        :order-id="orderId"
        :is-supplier="true"
        :attachment-list="attachmentList"
        :trade-id="tradeId"
        :preview-api="previewSupplierBiddingFileApi"
        :download-api="downloadSupplierBiddingFileApi"
      />
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import ApplyContentLock from '@/components/common/ApplyContentLock'
import ClarifiedFile from '@/components/bid/ClarifiedFile'

import {
  previewSupplierBiddingFileApi,
  downloadSupplierBiddingFileApi,
  supplierGetClarifiedFileApi
} from '@/api/supplier/bid'

import { paymentStatusDict } from '@/dictionary/project/common'

export default {
  name: 'InviteBidFile',

  components: {
    BaseSectionTitle,
    ApplyContentLock,
    ClarifiedFile
  },

  props: {
    // 招标单id
    orderId: {
      type: [Number, String],
      default: 0
    },
    tradeId: {
      type: [Number, String],
      default: 0
    },
    bookFeeStatus: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      previewSupplierBiddingFileApi,
      downloadSupplierBiddingFileApi,
      attachmentList: []
    }
  },

  computed: {
    // 是否已支付标书费
    hasPayBookFee() {
      return (
        this.bookFeeStatus == paymentStatusDict.SUCCESS.value ||
        this.bookFeeStatus == paymentStatusDict.FREE.value
      )
    }
  },

  watch: {
    tradeId: {
      handler: function(val) {
        this.getChangeFileFind()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 查询文件澄清
     */
    async getChangeFileFind() {
      if (!this.tradeId) return
      try {
        const _data = await supplierGetClarifiedFileApi(
          this.orderId,
          this.tradeId
        )
        this.attachmentList = _data.data || []
      } catch (err) {
        this.$message.error(err.message || '获取文件澄清信息失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-section {
  width: 700px;
}
</style>
